// Currently we have to manually import all locales we want to support in the app.
// https://github.com/date-fns/date-fns/issues/3660
const LocaleLoaders = {
  de: () => import( /* webpackMode: "lazy", webpackChunkName: "df-de" */
  'date-fns/locale/de'),
  'en-GB': () => import( /* webpackMode: "lazy", webpackChunkName: "df-en-GB" */
  'date-fns/locale/en-GB'),
  'en-US': () => import( /* webpackMode: "lazy", webpackChunkName: "df-en-US" */
  'date-fns/locale/en-US'),
  es: () => import( /* webpackMode: "lazy", webpackChunkName: "df-es" */
  'date-fns/locale/es'),
  fr: () => import( /* webpackMode: "lazy", webpackChunkName: "df-fr" */
  'date-fns/locale/fr'),
  hu: () => import( /* webpackMode: "lazy", webpackChunkName: "df-hu" */
  'date-fns/locale/hu'),
  it: () => import( /* webpackMode: "lazy", webpackChunkName: "df-it" */
  'date-fns/locale/it'),
  nl: () => import( /* webpackMode: "lazy", webpackChunkName: "df-nl" */
  'date-fns/locale/nl'),
  pt: () => import( /* webpackMode: "lazy", webpackChunkName: "df-pt" */
  'date-fns/locale/pt'),
  tr: () => import( /* webpackMode: "lazy", webpackChunkName: "df-tr" */
  'date-fns/locale/tr')
};

export { LocaleLoaders };
//# sourceMappingURL=locales.js.map
